import { FraudThreshold } from '@/modules/employer/components/SetupEmployer/SetupEmployer.types';
import { storeCreator } from '@/utils/store/store.utils';

const INIT_STATE = {};

interface State {
  state: FraudThreshold;
  setFraudThreshold: (value: FraudThreshold) => void;
}

const useStore = storeCreator<State>((set) => ({
  state: INIT_STATE,
  setFraudThreshold: (newState: FraudThreshold) => set((oldState) => ({
    state: {
      ...oldState.state,
      ...newState,
    },
  })),
}));
const useFraudThresholdStore = () => ({ ...useStore() });

export default useFraudThresholdStore;
